module.exports = __webpack_public_path__ + "static/media/tableBlack.129c3c96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calls/tableBlack.svg
// module id = 478
// module chunks = 0